module.exports = __webpack_public_path__ + "static/media/iconWspColor.11a9e6dc.svg";